var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12043_207997)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2871 3.27925C16.5474 3.0189 16.9695 3.0189 17.2299 3.27925L19.8965 5.94591C20.1569 6.20626 20.1569 6.62837 19.8965 6.88872C19.6362 7.14907 19.2141 7.14907 18.9537 6.88872L16.2871 4.22206C16.0267 3.96171 16.0267 3.5396 16.2871 3.27925Z",
    fill: "#B08C3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1869 5.28438C14.4541 5.01718 14.8874 5.01718 15.1546 5.28438L17.8914 8.02122C18.1586 8.28842 18.1586 8.72164 17.8914 8.98884L10.023 16.8573C9.93879 16.9414 9.83408 17.0022 9.7192 17.0335L5.95605 18.0599C5.71917 18.1245 5.46583 18.0572 5.29221 17.8836C5.11859 17.7099 5.05132 17.4566 5.11592 17.2197L6.14224 13.4566C6.17357 13.3417 6.23433 13.237 6.31853 13.1528L14.1869 5.28438ZM7.41463 13.9919L6.75117 16.4246L9.18385 15.7612L16.44 8.50503L14.6707 6.73581L7.41463 13.9919Z",
    fill: "#B08C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12043_207997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9784,
    height: 19.9784,
    fill: "white",
    transform: "translate(0.626953 0.511719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5211cc9190f75699d7530b9471b5e7bc.svg";
export { ForwardRef as ReactComponent };